import { Typography } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { getFooterLinks, getRouteTranslations } from '../../constants';
import * as Styled from './Footer.styles';

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  const { privacyPolicy, termsOfUse } = useMemo(
    () => getRouteTranslations(),
    [],
  );

  const { supportLink } = useMemo(() => getFooterLinks(), []);

  return (
    <Styled.Footer id="footer">
      <Styled.Container>
        <Styled.Copyright variant="body16">
          {t('footer.copyright', { year })}
        </Styled.Copyright>

        <Styled.Nav>
          <Typography variant="body16">
            <Styled.NavLink to={privacyPolicy}>
              {t('footer.privacyPolicy')}
            </Styled.NavLink>
          </Typography>

          <Styled.Separator>|</Styled.Separator>

          <Typography variant="body16">
            <Styled.NavLink to={termsOfUse}>
              {t('footer.termsOfService')}
            </Styled.NavLink>
          </Typography>

          <Styled.Separator>|</Styled.Separator>

          <Styled.Help variant="body16">
            <span>{t('footer.help')}:</span>
            <Styled.EmailLink href={`mailto:${supportLink}`}>
              {supportLink}
            </Styled.EmailLink>
          </Styled.Help>
        </Styled.Nav>
      </Styled.Container>
    </Styled.Footer>
  );
};

export default Footer;
